import { useEffect, useState } from "react";

import ModalMotion, {
  AnimateDirection,
} from "@/components/Molecules/ModalMotion";

import OneOnOneYogaForm from "../OneOnOneYogaForm";

import { classNameGenerator } from "@/utils";

import styles from "./OneOnOneYogaModal.module.scss";

interface OneOnOneYogaModalProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

const OneOnOneYogaModal: React.FC<OneOnOneYogaModalProps> = ({
  showModal,
  setShowModal,
}) => {
  const cls = classNameGenerator(styles);

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isFormSubmitted) {
      timer = setTimeout(() => {
        setIsFormSubmitted(false);
        setShowModal(false);
      }, 5000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isFormSubmitted, setShowModal]);

  return showModal ? (
    <ModalMotion
      overlayClosable
      onClose={() => setShowModal(false)}
      width="520px"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      className={cls("oneOnOneYogaModal")}
    >
      <OneOnOneYogaForm showModal={showModal} setShowModal={setShowModal} />
    </ModalMotion>
  ) : (
    <></>
  );
};

export default OneOnOneYogaModal;
